import { render, staticRenderFns } from "./ChemCPP1210Oct10Q1.vue?vue&type=template&id=20253655&scoped=true&"
import script from "./ChemCPP1210Oct10Q1.vue?vue&type=script&lang=js&"
export * from "./ChemCPP1210Oct10Q1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20253655",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
